exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".freemium-carousel {\n  height: 100%;\n  position: relative;\n  transition: 0.7s ease;\n  outline: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n  .freemium-carousel__slide {\n    height: 100%;\n    display: inline-block;\n    width: 50%;\n    position: absolute;\n    transition: 0.3s ease;\n    padding: 0 0.7em; }\n", ""]);

// exports
